import ContractPendingApproval from './ContractPendingApproval';

export default ContractPendingApproval;
